import React, { useState, useEffect } from 'react';
import SelectTimeline from './../SelectTimeline/SelectTimeline';
import Button from '@mui/material/Button';
import './Landing.scss'
import campaignWeathervaneLogo from './../../assets/img/campaign-weathervane-logo.webp';
import timeMachineImg from './../../assets/img/time-machine.png';
import SelectDropdown from './../SelectTimeline/SelectDropdown';
import { EARLIEST_AVAILABLE_YEAR } from '../../constants'
import CarouselModal from './../Landing/CarouselModal';
import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";
import Box from "@mui/material/Box";
import roperLogo from './../../assets/img/roper_game_logo.svg';


const style = {
    position: "relative",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "60%",
    bgcolor: "background.paper",
    padding: 5,
    borderRadius: "10px",

};


const localStorage = window.localStorage;

function Landing(props) {
    const [timeline, setTimeline] = useState(EARLIEST_AVAILABLE_YEAR)

    useEffect(() => {
        localStorage.clear()
    }, [])

    function handleTimelineChange(year) {
        setTimeline(year)
    }

    const [open, setOpen] = useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    const GameOnboardingCarousel = () => {
        return (
            <div>
                <Modal
                    aria-labelledby="transition-modal-title"
                    aria-describedby="transition-modal-description"
                    open={open}
                    onClose={handleClose}
                    closeAfterTransition>
                    <Fade in={open}>
                        <Box sx={style}>
                            <CarouselModal handleCloseModal={handleClose} />
                        </Box>
                    </Fade>
                </Modal>
            </div>

        )
    }

    return (
        <div className="container landing-container">
            <GameOnboardingCarousel />
            <div className="img-container">
                <img className="campaign-weathervane-logo" src={campaignWeathervaneLogo} alt={"Campaign Weathervane logo"} />
            </div>
            <div className='d-flex justify-content-center'>
                <Button aria-label='How to Play' disableElevation size='sm' 
                sx={{ color: 'black', borderRadius: '50px' }} 
                variant="outlined" 
                onClick={handleOpen}>
                How to play
                </Button>
            </div>
            <main>
                <div>
                    <h1 className="text-center">Jump into the time machine and select your year!</h1>
                    <h2>
                        Hello time-traveler! Let’s go back in time to win the presidency and change the world for the better!
                        Navigate the winds of public opinion through American history, you’ll answer each question according
                        to how you think the American public would have felt at the time. Your goal is to gain favorability and,
                        ultimately, a seat in the Oval Office!
                    </h2>
                </div>
                <div className='select-timeline'>
                    <SelectTimeline handleChange={handleTimelineChange} gameData={props.gameData} />
                </div>
                <div className='select-dropdown'><SelectDropdown handleChange={handleTimelineChange} gameData={props.gameData} /></div>
                <div className='selected-year mb-2'>Selected year: <strong>{timeline}</strong></div>
                <div className="btn-wrapper mb-5">
                    <Button className='button-primary'
                        aria-label='Jump into the time machine'
                        onClick={() => props.navigate(2, { score: 50, timeline: timeline, gameStopNumber: 1 })}>
                        Jump into the time machine
                    </Button>
                </div>
            </main>
            <footer>
                <div className="img-container">
                    <img className="time-machine-img" src={timeMachineImg} alt={"Time Machine image"} />
                    <div className='powered-by-container'>
                        <p className='powered-by'>Powered by</p>
                        <a target="_blank" rel="noopener noreferrer" href="https://ropercenter.cornell.edu/">
                            <img className="roper-logo-img" src={roperLogo} alt={"Roper Center logo"} />
                        </a>
                    </div>
                </div>
            </footer>
        </div>
    );
}

export default Landing;
